export default "__VITE_PUBLIC_ASSET__d7d95083__"